export default import.meta.ROLLUP_FILE_URL_D8wNmb_A;